import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import classnames from 'classnames';

import { TASK_TYPES } from 'utils/Constants';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import { Title } from 'components/Misc/Typography';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const basicClassName = classnames(
	'py-2 px-3 flex items-center space-x-2 border-4 rounded-lg transition-all',
	'dark:border-neutral-800 dark:bg-neutral-800',
	'border-white bg-white'
);

const linkClassName = classnames(
	'py-2 px-3 flex items-center space-x-2 border-4 rounded-lg cursor-pointer transition-all',
	'dark:border-neutral-800 dark:bg-neutral-800 hover:dark:bg-neutral-900',
	'border-white bg-white hover:bg-neutral-50'
);

const Task = ({ task }) => {
	// Cache exam's id
	const { id } = useParams();

	// Use exam's student store
	const state = useExamStudentStore(state => state.take.state);
	const summary = useExamStudentStore(state => state.summaries.find(s => s.taskId === task.id));

	// Find type info
	const type = useMemo(() => TASK_TYPES.find(type => type.value === task.type), [task.type]);

	if (state !== 'reviewed') {
		return (
			<div className={basicClassName}>
				<Title
					title={`${task.order}. uzdevums`}
					subtitle={type?.text}
					className="flex-1"
				/>

				<Show if={state === 'assigned' || state === 'finished'}>
					<Pill name={`${task.sample * task.points} punkti`} />
				</Show>

				<Show if={state == 'rejected'}>
					<Pill name={`${summary?.score} / ${task.sample * task.points}`} />
				</Show>
	
				<Pill name={`${task.sample} jautājumi`} />
			</div>
		);
	}

	return (
		<Link to={`/exams/task/${id}/${task.id}`} className={linkClassName}>
			<Title
				title={`${task.order}. uzdevums`}
				subtitle={type?.text}
				className="flex-1"
			/>

			<Show if={state === 'active' || state === 'finished'}>
				<Pill name={`${task.sample * task.points} punkti`} />
			</Show>

			<Show if={state == 'reviewed'}>
				<Pill name={`${summary?.score} / ${task.sample * task.points}`} />
			</Show>

			<Pill name={`${task.sample} jautājumi`} />
		</Link>
	);
};

export default Task;